<button
  nz-button
  nzNoAnimation
  nz-dropdown
  [nzType]="dropdown.button.type"
  [nzDanger]="dropdown.button.danger || false"
  [nzGhost]="dropdown.button.ghost || false"
  [nzSize]="dropdown.button.size || ''"
  [nzShape]="dropdown.button.shape || ''"
  [nzGhost]="dropdown.button.ghost || false"
  [disabled]="disabled"
  [nzDropdownMenu]="menu"
  style="border: none; padding: 0;"
>
  <i
    *ngIf="dropdown.button.faClassPrefix"
    [style]="dropdown.button.text ? 'margin-right: 5px;' : ''"
    class="fal"
    [ngClass]="dropdown.button.faClassPrefix"
  ></i>
  <i
    [ngClass]="dropdown.button.text ? '' : 'm-0'"
    *ngIf="dropdown.button.nzTypePrefix"
    nz-icon
    [nzType]="dropdown.button.nzTypePrefix"
  ></i>
  <ng-content select="[btn-prefix]"></ng-content>
  {{ dropdown.button.text | titlecase }}
  <i
    *ngIf="dropdown.button.faClassSuffix"
    [style]="dropdown.button.text ? 'margin-left: 5px;' : ''"
    class="fal"
    [ngClass]="dropdown.button.faClassSuffix"
  ></i>
  <i
    [ngClass]="dropdown.button.text ? '' : 'm-0'"
    *ngIf="dropdown.button.nzTypeSuffix"
    nz-icon
    [nzType]="dropdown.button.nzTypeSuffix"
  ></i>
</button>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li
      nz-menu-item
      *ngFor="let dropdownItem of dropdown.list"
      (click)="itemClick($event, dropdownItem.value)"
    >
      {{ dropdownItem.text }}
    </li>
  </ul>
</nz-dropdown-menu>
